import { render, staticRenderFns } from "./market.vue?vue&type=template&id=9b48a67c&scoped=true"
var script = {}
import style0 from "./market.vue?vue&type=style&index=0&id=9b48a67c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b48a67c",
  null
  
)

export default component.exports